import React from 'react';
import useMaintenanceGrade from '@di-shared/features/diag/cpo/useMaintenanceGrade';
import {t} from '@di-shared/features/common/useInferableTranslation';
import {ERROR} from '@di-shared/const';
import useCldrDatetimeFormatter from '@di-shared/utils/useCldrDatetimeFormatter';

interface DiagCpoRecallProps {
  vin: string;
}

function DiagCpoRecall({vin}: DiagCpoRecallProps) {
  const {recallInfos} = useMaintenanceGrade(vin);
  const CldrDatetimeFormatter = useCldrDatetimeFormatter();
  return (
    <section className="section section_certification_inspect">
      <ul className="inspect_require_list">
        {recallInfos.map(({occurrenceDate, inspectionDetail}) => (
          <li
            className="inspect_require_item"
            key={occurrenceDate + inspectionDetail}
          >
            <div className="inspect_require_info">
              <strong
                className="inspect_require_title"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {inspectionDetail}
              </strong>
              <span className="inspect_require_date">
                {t('T30369_$date', {date: occurrenceDate ? CldrDatetimeFormatter.format(occurrenceDate, 'yMMMd') : ERROR.DASH})}
              </span>
            </div>

            <div className="badge_box">
              <span className="badge badge_container_red badge_20px">{t('T20080')}</span>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default DiagCpoRecall;
